"use client";

import { FC } from "react";
import { useRouter } from "next/navigation";
import BankLogoComponent from "@portal/components/atoms/bankLogo";
import { IBankLogoButton } from "./types";

const BankLogoButton: FC<IBankLogoButton> = ({ centerId }) => {
  const router = useRouter();

  return (
    <button onClick={() => router.push("/")}>
      <BankLogoComponent centerId={centerId} />
    </button>
  );
};

export default BankLogoButton;
